
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoCreditNoteAppDtDialog extends Serenity.Extensions.GridEditorDialog<PoCreditNoteDtRow> {
        protected getFormKey() { return PoCreditNoteDtForm.formKey; }
        // protected getIdProperty() { return PoCreditNoteDtRow.idProperty; }
        protected getLocalTextPrefix() { return PoCreditNoteDtRow.localTextPrefix; }
        protected getNameProperty() { return PoCreditNoteDtRow.nameProperty; }
        // protected getService() { return PoCreditNoteAppDtService.baseUrl; }
        // protected getDeletePermission() { return PoCreditNoteDtRow.deletePermission; }
        // protected getInsertPermission() { return PoCreditNoteDtRow.insertPermission; }
        // protected getUpdatePermission() { return PoCreditNoteDtRow.updatePermission; }

        protected form = new PoCreditNoteDtForm(this.idPrefix);
        public qnNo: number;
        public purprice: number;
        public StkUnitT: string;
        public purratio: number;
        public purpz: number;
        public lsprun: number;

        constructor() {
            super();
            this.form = new PoCreditNoteDtForm(this.idPrefix);

                  

        }
        private get StkUnit() {
            return this.form.UnitChange.value != "0";
        }
        private get PurUnit() {
            return this.form.UnitChange.value != "1";
        }



        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

           
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }

       
        protected beforeLoadEntity() {
            let self = this;



            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();
            let f = this.form;
            // if (f.SkuCode.value != null) {
            /* let self = this;*/

            // self.toolbar.findButton("button-skucode").addClass("skuStockStatus");
            // self.toolbar.findButton('button-newdelete').addClass("skuEssential");
            // }

        }

       
    }
}